import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull, get } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import {
  REQUEST_PENDING_CLAIMS,
  REQUEST_SEARCH_PENDING_CLAIMS,
} from 'containers/PendingClaimsPage/constants';
import {
  setPendingClaims,
  setSearchPendingClaims,
} from 'containers/PendingClaimsPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* requestPendingClaims(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { status, page, pageSize } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}&isIntervenant=true`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setPendingClaims);
}

export function* requestPendingClaimsSaga() {
  yield takeLeading(REQUEST_PENDING_CLAIMS, requestPendingClaims);
}
export function* requestSearchPendingClaims(action: any) {
  const { token, searchQuery } = action;
  const tokenApi = token ? token : get(userToken.get(), 'token');
  const path = token
    ? `/corporeal/common/search?isIntervenant=true`
    : `/corporeal/common/search`;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${tokenApi}`,
    },
    body: JSON.stringify(searchQuery),
  };
  yield callApi(path, {}, options, [], setSearchPendingClaims);
}

export function* requestSearchPendingClaimsSaga() {
  yield takeLeading(REQUEST_SEARCH_PENDING_CLAIMS, requestSearchPendingClaims);
}

export default [requestPendingClaimsSaga, requestSearchPendingClaimsSaga];
